<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>Register</v-card-title>
          <v-card-text>
            <v-text-field label="Email" v-model="email"></v-text-field>
            <v-text-field
              label="Password"
              type="password"
              v-model="password"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" rounded @click="signUp()">Sign Up</v-btn>
            <v-btn color="primary" rounded outlined to="/login">Log In</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapMutations } from "vuex";
import firebase from "firebase";
export default {
  data() {
    return {
      email: "",
      password: ""
    };
  },
  methods: {
    ...mapMutations(["setUser"]),
    signUp() {
      const self = this;
      if (this.email !== "") {
        firebase
          .auth()
          .createUserWithEmailAndPassword(this.email, this.password)
          .then(
            function(user) {
              alert("Your account has been created !");
              self.setUser(user);
              self.$router.push("/");
            },
            function(err) {
              alert("Something went wrong" + err.message);
            }
          );
      } else {
        alert("Please enter your email address");
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
